import { makeStyles, MenuItem, Select } from "@material-ui/core";
import { isNationwideDelivery } from "@saleor/motherOrders/utils/handlers";
import {
  OrderVerticalType,
  SmopOrderStatusEnum
} from "@saleor/types/globalTypes";
import * as React from "react";

import OrderStatus from "../../OrderStatus";

const useStyles = makeStyles(
  () => ({
    disabled: {
      opacity: "0.5",
      pointerEvents: "none"
    }
  }),
  { name: "DropdownStatus" }
);

interface DropdownStatusProps {
  order: any;
  onOverrideStatus: (
    orderId: string,
    orderStatus: SmopOrderStatusEnum,
    newOrderStatus: SmopOrderStatusEnum,
    courier?: string
  ) => void;
  onUpdateStatus: (
    orderId: string,
    orderStatus: SmopOrderStatusEnum,
    newOrderStatus: SmopOrderStatusEnum,
    courier?: string
  ) => void;
  onCancelStatus: (courier: string, orderId: string) => void;
  disabled: boolean;
}

const DropdownStatus: React.FC<DropdownStatusProps> = props => {
  const classes = useStyles(props);
  const {
    order,
    onOverrideStatus,
    onUpdateStatus,
    onCancelStatus,
    disabled
  } = props;

  return (
    <div className={disabled ? classes.disabled : null}>
      <Select
        id={`componentDropdownStatus${
          order?.orderCode
        }-${order?.smopStatus.replace(/\s+/g, "")}`}
        onClick={e => e.stopPropagation()}
        fullWidth
        displayEmpty
        value={""}
      >
        <MenuItem value="" disabled hidden>
          <div style={{ margin: "3px" }}>
            <OrderStatus status={order.smopStatus} />
          </div>
        </MenuItem>

        {order.smopStatus === SmopOrderStatusEnum.NEW_ORDER ? (
          <div>
            <MenuItem
              value={SmopOrderStatusEnum.ACKNOWLEDGED}
              onClick={() =>
                onOverrideStatus(
                  order?.id,
                  SmopOrderStatusEnum.NEW_ORDER,
                  SmopOrderStatusEnum.ACKNOWLEDGED,
                  order?.courier
                )
              }
            >
              {" "}
              <OrderStatus status={SmopOrderStatusEnum.ACKNOWLEDGED} />
            </MenuItem>
            <MenuItem
              value={SmopOrderStatusEnum.READY}
              onClick={() =>
                onOverrideStatus(
                  order?.id,
                  SmopOrderStatusEnum.NEW_ORDER,
                  SmopOrderStatusEnum.READY,
                  order?.courier
                )
              }
            >
              <OrderStatus status={SmopOrderStatusEnum.READY} />
            </MenuItem>
          </div>
        ) : order.smopStatus === SmopOrderStatusEnum.ACKNOWLEDGED ? (
          <div>
            <MenuItem
              value={SmopOrderStatusEnum.READY}
              onClick={() =>
                onOverrideStatus(
                  order?.id,
                  SmopOrderStatusEnum.ACKNOWLEDGED,
                  SmopOrderStatusEnum.READY,
                  order?.courier
                )
              }
            >
              <OrderStatus status={SmopOrderStatusEnum.READY} />
            </MenuItem>
          </div>
        ) : order.smopStatus === SmopOrderStatusEnum.READY ? (
          <div>
            <MenuItem
              value={SmopOrderStatusEnum.COLLECTED}
              onClick={() =>
                onUpdateStatus(
                  order?.id,
                  SmopOrderStatusEnum.READY,
                  SmopOrderStatusEnum.COLLECTED,
                  order?.courier
                )
              }
            >
              {" "}
              <OrderStatus status={SmopOrderStatusEnum.COLLECTED} />
            </MenuItem>
            <MenuItem
              value={SmopOrderStatusEnum.SHIPPED}
              onClick={() =>
                onUpdateStatus(
                  order?.id,
                  SmopOrderStatusEnum.READY,
                  SmopOrderStatusEnum.SHIPPED,
                  order?.courier
                )
              }
            >
              <OrderStatus status={SmopOrderStatusEnum.SHIPPED} />
            </MenuItem>
          </div>
        ) : order.smopStatus === SmopOrderStatusEnum.COLLECTED ? (
          <div>
            <MenuItem
              value={SmopOrderStatusEnum.SHIPPED}
              onClick={() =>
                onUpdateStatus(
                  order?.id,
                  SmopOrderStatusEnum.COLLECTED,
                  SmopOrderStatusEnum.SHIPPED,
                  order?.courier
                )
              }
            >
              {" "}
              <OrderStatus status={SmopOrderStatusEnum.SHIPPED} />
            </MenuItem>
          </div>
        ) : order.smopStatus === SmopOrderStatusEnum.SHIPPED ? (
          <div>
            {order?.verticalType !== OrderVerticalType.FOOD_AND_BEVERAGES &&
            order.payments[0].paymentMethodType === "cash" ? (
              <>
                <MenuItem
                  value={SmopOrderStatusEnum.RETURN_TO_FC}
                  onClick={() =>
                    onUpdateStatus(
                      order?.id,
                      SmopOrderStatusEnum.SHIPPED,
                      SmopOrderStatusEnum.RETURN_TO_FC,
                      order?.courier
                    )
                  }
                >
                  <OrderStatus status={SmopOrderStatusEnum.RETURN_TO_FC} />
                </MenuItem>
              </>
            ) : (
              <></>
            )}
            <>
              <MenuItem
                value={SmopOrderStatusEnum.COMPLETED}
                onClick={() =>
                  onUpdateStatus(
                    order?.id,
                    SmopOrderStatusEnum.SHIPPED,
                    SmopOrderStatusEnum.COMPLETED,
                    order?.courier
                  )
                }
              >
                <OrderStatus status={SmopOrderStatusEnum.COMPLETED} />
              </MenuItem>
              <MenuItem
                value={SmopOrderStatusEnum.CANCELED}
                onClick={() => onCancelStatus(order?.courier, order?.id)}
              >
                <OrderStatus status={SmopOrderStatusEnum.CANCELED} />
              </MenuItem>
            </>
          </div>
        ) : order.smopStatus === SmopOrderStatusEnum.RETURN_TO_FC ? (
          <div>
            {order?.verticalType !== OrderVerticalType.FOOD_AND_BEVERAGES ? (
              <>
                <MenuItem
                  value={SmopOrderStatusEnum.SHIPPED}
                  onClick={() =>
                    onUpdateStatus(
                      order?.id,
                      SmopOrderStatusEnum.RETURN_TO_FC,
                      SmopOrderStatusEnum.SHIPPED,
                      order?.courier
                    )
                  }
                  disabled={isNationwideDelivery(
                    order?.shippingMethod?.deliveryType
                  )}
                >
                  <OrderStatus status={SmopOrderStatusEnum.SHIPPED} />
                </MenuItem>
                <MenuItem
                  value={SmopOrderStatusEnum.CANCELED}
                  onClick={() => onCancelStatus(order?.courier, order?.id)}
                >
                  <OrderStatus status={SmopOrderStatusEnum.CANCELED} />
                </MenuItem>
              </>
            ) : (
              <></>
            )}
          </div>
        ) : order.smopStatus === SmopOrderStatusEnum.RECEIVED_AT_FC ? (
          <div>
            <MenuItem
              value={SmopOrderStatusEnum.SHIPPED}
              onClick={() =>
                onUpdateStatus(
                  order?.id,
                  SmopOrderStatusEnum.RECEIVED_AT_FC,
                  SmopOrderStatusEnum.SHIPPED,
                  order?.courier
                )
              }
            >
              <OrderStatus status={SmopOrderStatusEnum.SHIPPED} />
            </MenuItem>
          </div>
        ) : null}
      </Select>
    </div>
  );
};

export default DropdownStatus;
